<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center" class="mt-n8 mx-1 mb-4">
          <span style="font-size: 34px; color: #616161"
            >Conciliaciones bancarias
          </span>
        </v-row>
        <v-row justify="center" class="mb-1 mt-n4">
          <search-header
            :show_department="false"
            :show_location="false"
            :show_accounts="false"
            :show_weeks="false"
            :show_refresh="false"
            @dataFilters="getData($event)"
          />
        </v-row>
        <v-card class="rounded-lg mt-n3">
          <v-expand-transition>
            <v-row v-if="loading" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                >
                </v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table
              v-else
              height="60vh"
              :search="search"
              :headers="headers"
              :items-per-page="15"
              :items="conciliation"
              class="elevation-0"
              dense
              hide-default-footer
      
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-toolbar-title
                    >Conciliaciones </v-toolbar-title
                  >
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Buscar..."
                    class="mt-6"
                    v-model="search"
                  ></v-text-field>
                  <v-spacer></v-spacer>
            
               
          
                      <v-btn
                        @click="goConcilation"
                        color="primary"
                        dark
                        class="mb-2"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>add</v-icon>
                        Nueva conciliacion
                      </v-btn>
            
             
                </v-toolbar>
              </template>
              <template v-slot:[`item.invoice_number`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showInvoice(item.invoice_id)"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                  >
                    <span
                      class="red--text d-flex"
                      v-if="item.invoice_type_id == 5"
                    >
                      {{ item.invoice_type_name }}
                    </span>
                    {{ item.invoice_number }}
                  </span>
                </v-hover>
              </template>
              <template v-slot:[`item.total_amount`]="{ item }">
                <span>
                  {{ currencyFormat(item.total_amount) }}
                  {{ item.currency_code }}</span
                >
              </template>

              <template v-slot:[`item.entity_name`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="viewEntity(item.entity_id)"
                    style="font-size: 14px"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                    >{{ item.entity_name }}</span
                  ></v-hover
                >
              </template>
              <template v-slot:[`item.recorded`]="{ item }">
                <v-chip small color="success" v-if="item.recorded">
                  <span>Contabilizada </span>
                </v-chip>
                <v-chip
                  small
                  :color="
                    item.invoice_type_id != 5 ? 'warning' : 'grey lighten-1'
                  "
                  v-else
                >
                  <span class="text--primary">{{
                    item.invoice_type_id == 5
                      ? "No contabilizable"
                      : "Sin contabilizar"
                  }}</span>
                </v-chip>
              </template>
              <template v-slot:[`item.status_id`]="{ item }">
                <v-chip
                  small
                  outlined
                  color="success"
                  v-if="item.status_id == 1"
                >
                  Activa
                </v-chip>
                <v-chip small outlined color="red" v-else> Anulada </v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="item.status_id == 1 && item.invoice_type_id != 5"
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click="editItem(item, true)"
                      large
                    >
                      read_more
                    </v-icon>
                  </template>
                  <span>Copiar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="
                        !item.recorded &&
                        item.status_id == 1 &&
                        item.invoice_type_id != 5
                      "
                      v-bind="attrs"
                      v-on="on"
                      medium
                      color="warning"
                      class="mx-1"
                      @click="editItem(item, false)"
                      >edit</v-icon
                    >
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">token</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6"> No hay datos </v-row>
              </template>
              <template slot="footer">
                <v-row justify="center">
                  <v-container style="width: 70%" class="mt-4">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                    ></v-pagination>
                  </v-container>
                </v-row>
              </template>
            </v-data-table>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    loading: false,
    headers: [
      {
        text: "Fecha",
        align: "start",
        value: "invoice_number",
      },
      {
        text: "Cuenta bancaria",
        value: "business_unit_description",
       
      },
      { text: "Balance total", value: "entity_name" },
      { text: "Estado", value: "recorded" },
      { text: "Actions", value: "actions" },
    ],
    lastFilters: {},
    editedIndex: -1,
    editedItem: {},
    conciliation: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo contacto" : "Editar contacto";
    },
  },
  watch: {},
  created() {},
  methods: {
    async getData(data) {
      this.lastFilters = data;
      this.loading = true;

      this.loading = false;
    },
    goConcilation() {
        this.$router.push({
        name: "ConciliationBanking",
    
      });
    },
    changeBusiness(data) {
      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
    },
    clear() {
      this.editedItem = null;
      this.dialog = false;
    },
    async editItem(item, type) {
      this.editOrCopyStatus = true;
      const responseRequest = await this.api_Post("income/search_invoice_id", {
        number: item.invoice_id,
      });

      if (responseRequest.status == 200) {
        let invoice = await responseRequest.json();

        this.editedItem = Object.assign({}, invoice[0]);
        let data = this.editedItem;
        if (type === true) {
          data.invoice_id = 0;
        }
      }
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = [];
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style></style>
